import axios from './axios';
import { getConfig } from '../utils/sessionStorageUtils';
import { IBrand, IProduct } from '../interfaces/product';

import { IData, IDataPage } from '../interfaces/common';
import { ChronoResponse } from './chrono-response';

export const getUISectionsAll = async (url?: string) => {
  try {
    const result = await axios.get('/UISections/getFullData', getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const getUISectionByName = async (url?: string) => {
  try {
    const result = await axios.get<ChronoResponse<UISectionViewDto[]>>(`/UISections/Filtered/${url}`, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const getUIGroupById = async (id?: string) => {
  try {
    const result = await axios.get<ChronoResponse<UIComponentsGroupViewDto>>(`/UIComponentsGroups/${id}`, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const updateWholeSection = async ({ id, name, uiComponentWithRefUpdateDtos }: any) => {
  try {
    const result = await axios.put(
      `/UISections/UpdateWholeSection/${id}`,
      { id, name, uiComponentWithRefUpdateDtos },
      getConfig()
    );
    return result?.data;
  } catch (e) {
    throw e;
  }
};

export const updateWholeGroup = async (id?: string, data?: any) => {
  try {
    const result = await axios.put(`/UIComponentsGroups/UpdateWholeComponentsGroup/${id}`, data, getConfig());
    return result?.data;
  } catch (e) {
    throw e;
  }
};

export const bulkGroupUpdate = async (data?: any) => {
  try {
    const result = await axios.put(`/UIComponentsGroups/BulkUpdate/`, data, getConfig());
    return result?.data;
  } catch (e) {
    throw e;
  }
};

export const postChnageImage = async (data: any) => {
  try {
    const result = await axios.post('/UILocalizations/image', data, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const getLatestCollection = async (url?: string) => {
  try {
    const result = await axios.get<IDataPage<IProduct[]>>(
      '/Products/catalog/12/0?curr=EUR&filter[column]=IsLastestCollection&filter[value]=true&filter[option]=11',
      getConfig()
    );
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const updateLatestCollection = async (id: any) => {
  try {
    const result = await axios.put(`/Products/addToLastestCollection/${id}`, getConfig());
    return result?.data;
  } catch (e) {
    throw e;
  }
};

export const bulkAddLatestCollection = async (ids: any) => {
  try {
    const result = await axios.put(`/Products/AddToLastestCollection`, ids, getConfig());
    return result?.data;
  } catch (e) {
    throw e;
  }
};

export const bulkRemoveLatestCollection = async (ids: any) => {
  try {
    const result = await axios.put(`/Products/RemoveFromLastestCollection`, ids, getConfig());
    return result?.data;
  } catch (e) {
    throw e;
  }
};

export const postUISections = async (name: string) => {
  try {
    const result = await axios.post('/UISections', { name }, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const postUIComponents = async (key: string, uiComponentsGroupId: string) => {
  try {
    const result = await axios.post('/UIComponents', { key, uiComponentsGroupId }, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};
export const postUIGroups = async (uiSectionId?: string) => {
  try {
    const result = await axios.post('/UIComponentsGroups', { selected: true, uiSectionId }, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const deleteUIGroups = async (id: string) => {
  try {
    const result = await axios.delete(`/UIComponentsGroups/${id}`, getConfig());
    return result?.data;
  } catch (e) {
    throw e;
  }
};

export const postUILocalizations = async (value: string, language: string, uiComponentId: string, id?: string) => {
  try {
    const result = await axios.post('/UILocalizations', { value, language, uiComponentId }, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const postUILocalizationsImage = async (value: string, language: string, uiComponentId: string, id?: string) => {
  try {
    const result = await axios.post('/UILocalizations/image', { value, language, uiComponentId }, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const postBrands = async (ids: Array<string>) => {
  try {
    const result = await axios.put('/Brands/markShopByBrand', ids, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const getSelectedBrands = async (url?: string) => {
  try {
    const result = await axios.get(
      '/Brands/12/0?curr=EUR&filter[column]=ShopByBrand&filter[value]=true&filter[option]=11',
      getConfig()
    );
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const removeFromShopByBrand = async (ids?: any) => {
  try {
    const result = await axios.put('/Brands/RemoveFromShopByBrand', ids, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const addToShopByBrand = async (ids?: any) => {
  try {
    const result = await axios.put('/Brands/AddToShopByBrand', ids, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const addToShopByBrandProduct = async (ids?: any) => {
  try {
    const result = await axios.put('/Products/AddToShopByBrand', ids, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const removeFromShopByBrandProduct = async (ids?: any) => {
  try {
    const result = await axios.put('/Products/RemoveFromShopByBrand', ids, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const getSelectedBrandsProduct = async (brandName?: string) => {
  try {
    const result = await axios.get(
      `/Products/catalog/12/0?curr=EUR&filter[column]=ShopByBrand&filter[value]=true&filter[option]=11&filter[column]=BrandName&filter[value]=${brandName
        ?.replaceAll('/', '%2F')
        ?.replaceAll('&', '%26')}&filter[option]=11`,
      getConfig()
    );
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const getCategories = async (url?: string) => {
  try {
    const result = await axios.get('/Category', getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const getCategory = async (id: string) => {
  try {
    const result = await axios.get(`/Category/${id}`, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const deleteCategory = async (id: string) => {
  try {
    const result = await axios.delete(`/Category/${id}`, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const postCreateCategory = async (name: string) => {
  try {
    const result = await axios.post('/Category/create', { name }, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const putUpdateCategory = async (name: string, id: string) => {
  try {
    const result = await axios.put('/Category/update', { name, id }, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export interface ICreateArticle {
  title: string;
  content: string;
  tagsString: string[];
  categoriesString: string[];
  mainPhoto: string;
}

export const postCreateArticle = async ({
  categoriesString,
  content,
  mainPhoto,
  tagsString,
  title,
}: ICreateArticle) => {
  try {
    const result = await axios.post(
      '/Article/create',
      { title, content, tagsString, categoriesString, mainPhoto },
      getConfig()
    );
    return result.data;
  } catch (e) {
    throw e;
  }
};

export interface ITags {
  id: string;
  value: string;
  modifiedAt: string;
  createdAt: string;
}

interface ICategory {
  id: string;
  name: string;
  modifiedAt: string;
  createdAt: string;
}

interface IMainPhoto {
  url: string;
  fileName: string | null;
  path: string | null;
  containerName: string | null;
}

export interface IGetArticles {
  title: string;
  content: string;
  tags: ITags[];
  categories: ICategory[];
  mainPhoto: IMainPhoto[];
  id: string;
  createdAt: Date;
}

export const getArticles = async () => {
  try {
    const result = await axios.get(`/Article?sorting[column]=createdAt&sorting[order]=2`, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const deleteArticle = async (id: string) => {
  try {
    const result = await axios.delete(`/Article/${id}`, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const getArticle = async (id: string) => {
  try {
    const result = await axios.get<IData<IGetArticles>>(`/Article/${id}`, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const putUpdateArticle = async (
  { categoriesString, content, mainPhoto, tagsString, title }: ICreateArticle,
  id: string
) => {
  try {
    const result = await axios.put(
      '/Article/update',
      { categoriesString, content, mainPhoto, tagsString, title, id },
      getConfig()
    );
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const getArticlesByIndex = async (
  index: number,
  size?: number,
  title?: string
): Promise<IDataPage<IGetArticles[]> | null> => {
  try {
    const result = await axios.get<IDataPage<IGetArticles[]> | null>(
      `/Article/${size}/${index}?filter[column]=title&filter[value]=${title}&filter[option]=3&sortParametrs[sortOrder]=1&sortParametrs[columnName]=string&sorting[column]=createdAt&sorting[order]=2`,
      getConfig()
    );
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const randomArticles = async () => {
  try {
    const result = await axios.get<IDataPage<IGetArticles[]>>(`/Article/3/0`, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const getArticlesByTags = async (
  index: number,
  size?: number,
  tag?: string
): Promise<IDataPage<IGetArticles[]> | null> => {
  try {
    const result = await axios.get<IDataPage<IGetArticles[]> | null>(
      `/Article/byTags/${size}/${index}?tags=${tag}&sorting[column]=createdAt&sorting[order]=2`,
      getConfig()
    );
    return result.data;
  } catch (e) {
    throw e;
  }
};
export const getArticlesByCategories = async (index: number, size?: number, category?: string) => {
  try {
    const result = await axios.get<IDataPage<IGetArticles[]>>(
      `/Article/byCategories/${size}/${index}?categories=${category}&sorting[column]=createdAt&sorting[order]=2`,
      getConfig()
    );
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const getArticlesByTitle = async (title?: string) => {
  try {
    const result = await axios.get(
      `/Article?filter[column]=string&filter[value]=${title}&filter[option]=3&sortParametrs[sortOrder]=1&sortParametrs[columnName]=string&sorting[column]=createdAt&sorting[order]=2`,
      getConfig()
    );
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const getFeaturedBrand = async () => {
  try {
    const result = await axios.get<IDataPage<IBrand[]>>(
      `/Brands/12/0?filter[column]=FuturedBrand&filter[value]=1&filter[option]=11&sortParametrs[sortOrder]=1&sortParametrs[columnName]=string' `,
      getConfig()
    );
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const removeFromFeturedBrand = async (id: string) => {
  try {
    const result = await axios.put('/Brands/RemoveFromFutured', [id], getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};
export const addToFeaturedBrand = async (id: string) => {
  try {
    const result = await axios.put('/Brands/AddToFutured', [id], getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const addToWorkWith = async (id: string) => {
  try {
    const result = await axios.put('/Brands/AddToWorkWith', [id], getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const getWorkWithBrand = async () => {
  try {
    const result = await axios.get<IDataPage<IBrand[]>>(
      `/Brands/12/0?filter[column]=WorkWith&filter[value]=1&filter[option]=11&sortParametrs[sortOrder]=1&sortParametrs[columnName]=string' `,
      getConfig()
    );
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const removeFromWorkWith = async (id: string) => {
  try {
    const result = await axios.put('/Brands/RemoveFromWorkWith', [id], getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const putSwitchShopByBrand = async (idOld: string, idNew: string) => {
  try {
    const result = await axios.put('/Brands/SwitchShopByBrand', [idOld, idNew], getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};
export const putSwitchFutured = async (idOld: string, idNew: string) => {
  try {
    const result = await axios.put('/Brands/SwitchFutured', [idOld, idNew], getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};
export const putSwitchWorkWith = async (idOld: string, idNew: string) => {
  try {
    const result = await axios.put('/Brands/SwitchWorkWith', [idOld, idNew], getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const putAddOrRemoveLatestCollectionProduct = async (ids: string[]) => {
  try {
    const result = await axios.put('/Products/SwitchLastestCollection', ids, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};

export const putAddOrRemoveSwitchShopByBrandProduct = async (ids: string[]) => {
  try {
    const result = await axios.put('/Products/SwitchShopByBrand', ids, getConfig());
    return result.data;
  } catch (e) {
    throw e;
  }
};
